import(/* webpackMode: "eager" */ "/app/src/app/proyectos/sensorica/page.tsx");
